import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=0bea3cc4&scoped=true&"
import script from "./Catalog.vue?vue&type=script&lang=js&"
export * from "./Catalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea3cc4",
  null
  
)

export default component.exports